export default {

  defaults: {
    source: [],
    value:  'value',
    label:  'label'
  },

  /**
   *
   * @param args
   * @param itemData
   * @return {{value: *, label: *}}
   */
  mapItem (args, itemData) {
    return {
      value: itemData[args.value],
      label: itemData[args.label]
    }
  },

  /**
   *
   * @param args
   * @return {[{value: *, label: *}]}
   */
  map (args) {
    args = $.extend(true, {}, this.defaults, args)

    if (!args.source instanceof Array) {
      throw Error('source must be Array!')
    }

    let items = []
    for (let i = 0; i < args.source.length; i++) {
      let item = args.source[i],
          keys = Object.keys(item)

      if (keys.length <= 1) {
        keys.push(keys[0])
      }

      items.push({ value: item[keys[0]], label: item[keys[1]] })
    }

    return items
  }

  // @deprecated
  // /**
  //  *
  //  * @param args
  //  * @return {[{value: *, label: *}]}
  //  */
  // map (args) {
  //   args = $.extend(true, {}, this.defaults, args)
  //
  //   if (!args.source instanceof Array) {
  //     throw Error('source must be Array!')
  //   }
  //
  //   let items = [];
  //   for (let i = 0; i < args.source.length; i++) {
  //     let item = args.source[i]
  //
  //     if (!item.hasOwnProperty(args.value) ||
  // !item.hasOwnProperty(args.label)) { throw Error('item has not property
  // value: "' + args.value + '"  or label: "' + args.label + '"') }
  // items.push(this.mapItem(args, item)) }  return items }
}